
import styled from 'styled-components';
import theme from '../../../theme';

const StyledAuditCommittee = styled.section`
  padding: 2rem 0rem;
  .collapse-grill{
    .ant-collapse-item{
      border: none;
      .ant-collapse-header{
        color: ${theme.corellBlue};
      }
    }
  }
  .audit-table{
    .ant-table{
      border: 1px solid ${theme.LandingBlack};
      border-radius: 4px;
    }
    .ant-table-thead > tr > th{
      background: ${theme.btnGreen}20;
      font-weight: 600;
      border: 1px solid ${theme.LandingBlack};
    }
    .ant-table-tbody > tr > td{
      background: ${theme.whiteColor};
      border: 1px solid ${theme.LandingBlack};
    }
  }
`;
/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

const StyledBoardDirectors = styled.section`
  padding: 2rem 0rem;
  .directors-breadcrumb{
    margin-bottom: 1.5rem;
    .ant-breadcrumb-link{
      color: ${theme.hotRed};
      font-size: 1rem;
    }
    .current-breadcrumb{
      color: ${theme.LandingBlack};
      font-size: 1rem;
    }
  }
  .board-directors-card{
    border-radius: 12px;
    height: 100%;
    .ant-card-cover{
      img{
        width: 100%;
        height: 280px;
        object-fit: cover;
        border-bottom: 5px solid ${theme.primaryColor};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
    .ant-card-body{
      padding: 0px;
      .bd-card-meta{
        margin: 0px;
        .ant-card-meta-detail{
          text-align: center;
          padding: .8rem;
          border-bottom-left-radius: 11px;
          border-bottom-right-radius: 11px;
          .ant-card-meta-title{
            font-weight: 600;
            font-size: 1rem;
            color: ${theme.hotRed};
            white-space: normal;
          }
          .ant-card-meta-description{
            font-size: 14px;
            color: ${theme.LandingBlack};
          }
        }
      }
    }
    &:hover{
      box-shadow: 0px 0px 10px ${theme.borderGray};
      border: 1px solid ${theme.primaryColor}50;
    }
  }
  .directors-profile{
    border-radius: 20px;
    height: 100%;
    box-shadow: 0px 0px 10px ${theme.borderGray};
    .ant-card-body{
      padding: 20px;
      .director-img{
        width: 100%;
        height: 300px;
        object-fit: contain;
      }
      .text-black{
        color: ${theme.LandingBlack};
      }
      .fw-600{
        font-weight: 600;
      }
    }
  }
`;

export {
  StyledAuditCommittee,
  StyledBoardDirectors,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/StyledIPO.js